module.exports = __webpack_public_path__ + "static/media/sweap-circle.6078b016.png";